module.exports = __webpack_public_path__ + "img/description1.1c9ec832.jpg";